export enum GATEWAY_STATUS {
  ONLINE = 1,
  PARTIALLY_DISCONNECTED = 2,
  OFFLINE_OR_UNKNOWN = 3,
  MISSING = 4
}
